import { useDispatch } from 'react-redux';
// eslint-disable-next-line import/no-useless-path-segments
import MainPageBanner from '../../components/MainPageBanner';
import Login from '../../components/Login';
import { openLoginModal } from '../../store/reducers/modal/loginModalSlice';

const Registration = () => {
  const dispatch = useDispatch();
  dispatch(openLoginModal());
  return (
    <MainPageBanner>
      <Login />
    </MainPageBanner>
  );
};

export default Registration;
